import { useQuery } from '@tanstack/react-query'
import { format, subDays } from 'date-fns'
import { useAuth } from '@/lib/contexts/AuthContext'
import { getTrafficTrends } from '@/lib/api/external-api'

export const SITE_TREND_DAYS = 14

/**
 * Unique visitors per day for one site over the last 14 days (today last,
 * still counting), for the hub's Trend column. Real buckets from
 * `GET properties/:id/traffic/trends`; React Query shares one request per
 * site across remounts. Null until loaded or when the request fails, so the
 * cell shows nothing rather than an invented line.
 */
export function useSiteDailyVisitors(propertyId: string | undefined, enabled = true) {
  const { token } = useAuth()
  const end = new Date()
  const range = `${format(subDays(end, SITE_TREND_DAYS - 1), 'yyyy-MM-dd')}_${format(end, 'yyyy-MM-dd')}`

  return useQuery({
    queryKey: ['site-daily-visitors', propertyId, range],
    queryFn: async () => {
      const res = await getTrafficTrends(range, propertyId!, token!)
      return (res?.data ?? []).map((b) => ({ day: b.bucket_start, visitors: Number(b.unique_visitors) || 0 }))
    },
    enabled: enabled && Boolean(propertyId && token),
    staleTime: 10 * 60 * 1000,
    retry: false,
    refetchOnWindowFocus: false,
  })
}
